export const environment = {
    production: true,
    hmr: false,
    appConfig: './config/appconfig.development.json'
};
